<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-6"><a id="page_xxiii"><em>Abbreviations</em></a></h1><a id="page_xxiii">
<table>
<tbody>
<tr>
<td class="wid15">
<p class="t-left">AB</p></td>
<td class="wid80">
<p class="t-left">Anchor Bible</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">ABRL</p></td>
<td class="wid80">
<p class="t-left">Anchor Bible Reference Library</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">ABSA</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Annual of the British School at Athens</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">ANRW</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Aufstieg und Niedergang der römischen Welt: Geschichte und Kultur Roms im Spiegel der neueren Forschung</em>. Part 2, <em class="italic">Principat</em>. Edited by Hildegard Temporini and Wolfgang Haase. Berlin: de Gruyter, 1972–</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">ANTC</p></td>
<td class="wid80">
<p class="t-left">Abingdon New Testament Commentaries</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">AYB</p></td>
<td class="wid80">
<p class="t-left">Anchor Yale Bible</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">BBR</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Bulletin of Biblical Research</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">BCH</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Bulletin de correspondance hellénique</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">BDAG</p></td>
<td class="wid80">
<p class="t-left">Danker, Frederick W., Walter Bauer, William F. Arndt, and F. Wilbur Gingrich. <em class="italic">Greek-English Lexicon of the New Testament and Other Early Christian Literature</em>. 3rd ed. Chicago: University of Chicago Press, 2000</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">BECNT</p></td>
<td class="wid80">
<p class="t-left">Baker Exegetical Commentary on the New Testament</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">BICS</p></td>
<td class="wid80">
<p class="t-left">Bulletin of the Institute of Classical Studies</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">BTB</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Biblical Theology Bulletin</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">BZNW</p></td>
<td class="wid80">
<p class="t-left">Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">CBQ</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Catholic Biblical Quarterly</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">CIL</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Corpus Inscriptionum Latinarum</em>. Berlin, 1862–</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">CIPh</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">La colonie romaine: La vie publique de la colonie</em>. Vol. 2, part 1 of <em class="italic">Corpus des Inscriptions grecques et latines de Philippes</em>. Edited by Cédric Brélaz. Athens: École française d’Athènes, 2014</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">ClQ</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Classical Quarterly</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">CP</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Classical Philology</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">EC</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Early Christianity</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">GRBS</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Greek, Roman, and Byzantine Studies</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">GRNSC</p></td>
<td class="wid80">
<p class="t-left">Greece and Rome New Surveys in the Classics</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><a id="page_xxiv"><em class="italic">Hesperia</em></a></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Hesperia: The Journal of the American School of Classical Studies at Athens</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">HTR</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Harvard Theological Review</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">HTS</p></td>
<td class="wid80">
<p class="t-left">Harvard Theological Studies</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">IAph</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Inscriptions of Aphrodisias</em>. Edited by Joyce Reynolds, Charlotte Roueché, and Gabriel Bodard. 2007. <a href="https://www.insaph.kcl.ac.uk/insaph/iaph2007/index.html" target="_blank">https://insaph.kcl.ac.uk/insaph/iaph2007/index.html</a></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">IBC</p></td>
<td class="wid80">
<p class="t-left">Interpretation: A Bible Commentary for Teaching and Preaching</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">IBeroia</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Επιγραφές Κάτω Μακεδονίας: Μεταξύ του Βερμίου όρους και του Αξιού ποταμού; Τεύχος Α΄ Επιγραφές Βέροιας</em>. Edited by Loukretia Gounaropoulou and Miltiades B. Hatzopoulou. Athens: Diffusion de Boccard, 1998</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">IG</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Inscriptiones Graecae</em>. Editio Minor. Berlin: de Gruyter, 1924–</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">IGR</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Inscriptiones graecae ad res romanas pertinentes</em>. Edited by René Cagnat et al. 3 vols. Paris: Leroux, 1906–1927</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">IKnidos</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Die Inschriften von Knidos I</em>. Edited by Wolfgang Blümel. Inschriften griechischer Städte aus Kleinasien 41. Bonn: Rudolf Habelt, 1992</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">ILS</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Inscriptiones Latinae Selectae</em>. Edited by Hermann Dessau. 3 vols. Berlin: Weidmann, 1892–1916</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">IPergamon</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Die Inschriften von Pergamon</em>. Altertümer von Pergamon 8.1, 2. Edited by Max Fränkel. Berlin: Spemann, 1890–1895</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">IPriene</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Inschriften von Priene</em>. Edited by F. Hiller von Gaertringen. Berlin, 1906</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">IvO</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Die Inschriften von Olympia</em>. Edited by Wilhelm Dittenberger and Karl Purgold. Olympia 5. Berlin: Asher, 1896</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">JAJ</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Journal of Ancient Judaism</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">JBL</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Journal of Biblical Literature</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">JHS</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Journal of Hellenic Studies</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">JRA</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Journal of Roman Archaeology</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">JRS</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Journal of Roman Studies</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">JSNT</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Journal for the Study of the New Testament</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">JSNTSup</p></td>
<td class="wid80">
<p class="t-left">Journal for the Study of the New Testament Supplement Series</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">LCL</p></td>
<td class="wid80">
<p class="t-left">Loeb Classical Library</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">LSJ</p></td>
<td class="wid80">
<p class="t-left">Liddell, Henry George, and Robert Scott, Henry Stuart Jones. <em class="italic">A Greek-English Lexicon</em>. 9th ed. with revised supplement. Oxford: Clarendon, 1996</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">LTQ</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Lexington Theological Quarterly</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">NIB</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">The New Interpreter’s Bible</em>. Edited by Leander E. Keck. 12 vols. Nashville: Abingdon, 1994–2004</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">NICNT</p></td>
<td class="wid80">
<p class="t-left">New International Commentary on the New Testament</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">NovTSup</p></td>
<td class="wid80">
<p class="t-left">Supplements to Novum Testamentum</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><a id="page_xxv"><em class="italic">NTS</em></a></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">New Testament Studies</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">OCD</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Oxford Classical Dictionary</em>. Edited by Simon Hornblower and Antony Spawforth. 4th ed. Oxford: Oxford University Press, 2012</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">OGIS</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Orientis Graeci Inscriptiones Selectae</em>. Edited by Wilhelm Dittenberger. 2 vols. Leipzig: Hirzel, 1903–1905</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">Phil</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Philologus: Zeitschrift für das klassische Altertum</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">Pilhofer 2</p></td>
<td class="wid80">
<p class="t-left">Pilhofer, Peter. <em class="italic">Katalog der Inschriften von Philippi</em>. Vol. 2 of <em class="italic">Philippi</em>. WUNT 119. Tübingen: Mohr Siebeck, 2000</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">PNTC</p></td>
<td class="wid80">
<p class="t-left">Pillar New Testament Commentary</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">P.Oxy.</p></td>
<td class="wid80">
<p class="t-left"><em class="italic">The Oxyrhynchus Papyri</em>. Edited by Bernard P. Grenfell et al. London: Egypt Exploration Fund, 1898–</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">PW</p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Paulys Real-Encyclopädie der classischen Altertumswissenschaft</em>. New edition by Georg Wissowa and Wilhelm Kroll. 50 vols. in 84 parts. Stuttgart: Metzler and Druckenmüller, 1894–1980</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">RevPhil</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Revue de philologie</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">RGRW</p></td>
<td class="wid80">
<p class="t-left">Religions in the Graeco-Roman World</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">RPC</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Roman Provincial Coinage</em>. Edited by Andrew Burnett et al. London: British Museum Press; Paris: Bibliothèque Nationale, 1992–</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">RRE</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Religion in the Roman Empire</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">SALOP</p></td>
<td class="wid80">
<p class="t-left">The Society of Antiquaries of London Occasion Papers</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">SBLDS</p></td>
<td class="wid80">
<p class="t-left">Society of Biblical Literature Dissertation Series</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">SEG</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Supplementum epigraphicum graecum</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">Sel. Pap.</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Select Papyri</em>. Translated by Arthur S. Hunt and Campbell C. Edgar. 5 vols. LCL. Cambridge: Harvard University Press</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">SIG</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Sylloge Inscriptionum Graecarum</em>. Edited by Wilhelm Dittenberger. 4 vols. 3rd ed. Leipzig: Hirzel, 1915–1924</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">SNTSMS</p></td>
<td class="wid80">
<p class="t-left">Society for New Testament Studies Monograph Series</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">TDNT</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Theological Dictionary of the New Testament</em>. Edited by Gerhard Kittel and Gerhard Friedrich. Translated by Geoffrey W. Bromiley. 10 vols. Grand Rapids: Eerdmans, 1964–1976</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">WBC</p></td>
<td class="wid80">
<p class="t-left">Word Biblical Commentary</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">WGRWSup</p></td>
<td class="wid80">
<p class="t-left">Writings from the Greco-Roman World Supplement Series</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">WUNT</p></td>
<td class="wid80">
<p class="t-left">Wissenschaftliche Untersuchungen zum Neuen Testament</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">ZNW</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Zeitschrift für die neutestamentliche Wissenschaft und die Kunde der älteren Kirche</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">ZPE</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Zeitschrift für Papyrologie und Epigraphik</em></p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">ZST</em></p></td>
<td class="wid80">
<p class="t-left"><em class="italic">Zeitschrift für systematische Theologie</em></p></td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 011_Abbreviations.vue?054bb933